import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiEye, FiEyeOff, FiUploadCloud, FiFileText, FiShield, FiArrowLeft, FiArrowRight, FiZap, FiCheckCircle, FiAlertCircle } from 'react-icons/fi';
import CameraCapture from './CameraCapture.jsx';
import { getApiBaseUrl } from '../../utils/apiBaseUrl';
import '../home/Home.css';
import './Signupagence.css';

const apiBaseUrl = getApiBaseUrl();
const ENDPOINT_AGENCE = `${apiBaseUrl}/api/agencies/signup-request`;

const FORMULAIRE_INITIAL = {
	agencyName: '', ownerFullName: '', professionalEmail: '',
	phoneNumber: '', agencyAddress: '', website: '',
	password: '', confirmPassword: '', acceptedTerms: false,
};

const FICHIERS_INITIAUX = {
	rcDocument: null, nifDocument: null, ownerIdentityDocument: null,
	agencyFrontPhoto: null, ownerLivePhoto: null, agencyLogo: null,
};

function Signupagence() {
	const navigate = useNavigate();
	const [formulaire, setFormulaire] = useState(FORMULAIRE_INITIAL);
	const [fichiers, setFichiers] = useState(FICHIERS_INITIAUX);
	const [erreurs, setErreurs] = useState({});
	const [erreurGenerale, setErreurGenerale] = useState('');
	const [messageSucces, setMessageSucces] = useState('');
	const [chargement, setChargement] = useState(false);
	const [afficherMdp, setAfficherMdp] = useState(false);
	const [afficherConfirm, setAfficherConfirm] = useState(false);

	const handleChamp = (e) => {
		const { name, value } = e.target;
		setFormulaire((p) => ({ ...p, [name]: value }));
		setErreurs((p) => { const n = { ...p }; delete n[name]; return n; });
	};

	const handleCgu = (e) => {
		setFormulaire((p) => ({ ...p, acceptedTerms: e.target.checked }));
		setErreurs((p) => { const n = { ...p }; delete n.acceptedTerms; return n; });
	};

	const handleFichier = (e) => {
		const { name, files } = e.target;
		setFichiers((p) => ({ ...p, [name]: files?.[0] || null }));
		setErreurs((p) => { const n = { ...p }; delete n[name]; return n; });
	};

	const handlePhotoDirigeant = (file) => {
		setFichiers((p) => ({ ...p, ownerLivePhoto: file }));
		setErreurs((p) => { const n = { ...p }; delete n.ownerLivePhoto; return n; });
	};

	const validerFormulaire = () => {
		const e = {};
		if (!formulaire.agencyName.trim()) e.agencyName = "Le nom de l'agence est obligatoire.";
		if (!formulaire.ownerFullName.trim()) e.ownerFullName = 'Le nom du responsable est obligatoire.';
		if (!formulaire.professionalEmail.trim()) e.professionalEmail = "L'email professionnel est obligatoire.";
		else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formulaire.professionalEmail)) e.professionalEmail = 'Format email invalide.';
		if (!formulaire.phoneNumber.trim()) e.phoneNumber = 'Le numéro de téléphone est obligatoire.';
		if (!formulaire.agencyAddress.trim()) e.agencyAddress = "L'adresse est obligatoire.";
		if (formulaire.website && !/^https?:\/\/.+/.test(formulaire.website.trim())) e.website = 'Le site web doit commencer par http:// ou https://';
		if (!fichiers.rcDocument) e.rcDocument = 'Le document RC est obligatoire.';
		if (!fichiers.nifDocument) e.nifDocument = 'Le document NIF est obligatoire.';
		if (!fichiers.ownerIdentityDocument) e.ownerIdentityDocument = "La pièce d'identité est obligatoire.";
		if (!fichiers.agencyFrontPhoto) e.agencyFrontPhoto = "La photo façade est obligatoire.";
		if (!fichiers.ownerLivePhoto) e.ownerLivePhoto = "La photo sur place est obligatoire.";
		if (!formulaire.password) e.password = 'Le mot de passe est obligatoire.';
		else if (formulaire.password.length < 8) e.password = 'Minimum 8 caractères.';
		if (!formulaire.confirmPassword) e.confirmPassword = 'La confirmation est obligatoire.';
		else if (formulaire.password !== formulaire.confirmPassword) e.confirmPassword = 'Les mots de passe ne correspondent pas.';
		if (!formulaire.acceptedTerms) e.acceptedTerms = 'Vous devez accepter les conditions.';
		return e;
	};

	const handleSoumission = async (e) => {
		e.preventDefault();
		setErreurGenerale('');
		setMessageSucces('');

		const errs = validerFormulaire();
		if (Object.keys(errs).length > 0) { setErreurs(errs); return; }

		setChargement(true);
		setErreurs({});

		try {
			const payload = new FormData();
			payload.append('agencyName', formulaire.agencyName.trim());
			payload.append('ownerFullName', formulaire.ownerFullName.trim());
			payload.append('professionalEmail', formulaire.professionalEmail.trim());
			payload.append('phoneNumber', formulaire.phoneNumber.trim());
			payload.append('agencyAddress', formulaire.agencyAddress.trim());
			payload.append('website', formulaire.website.trim());
			payload.append('password', formulaire.password);
			payload.append('confirmPassword', formulaire.confirmPassword);
			payload.append('acceptedTerms', String(formulaire.acceptedTerms));
			payload.append('rcDocument', fichiers.rcDocument);
			payload.append('nifDocument', fichiers.nifDocument);
			payload.append('ownerIdentityDocument', fichiers.ownerIdentityDocument);
			payload.append('agencyFrontPhoto', fichiers.agencyFrontPhoto);
			payload.append('ownerLivePhoto', fichiers.ownerLivePhoto);
			if (fichiers.agencyLogo) payload.append('agencyLogo', fichiers.agencyLogo);

			const res = await fetch(ENDPOINT_AGENCE, { method: 'POST', body: payload });
			let body = null;
			try { body = await res.json(); } catch { body = null; }

			if (!res.ok) {
				if (body?.errors) setErreurs(body.errors);
				setErreurGenerale(body?.message || 'Impossible de soumettre votre dossier. Vérifiez les champs et réessayez.');
				return;
			}

			setMessageSucces('Votre demande a bien été envoyée. Notre équipe vous contactera sous 48h.');
			setFormulaire(FORMULAIRE_INITIAL);
			setFichiers(FICHIERS_INITIAUX);
			setAfficherMdp(false);
			setAfficherConfirm(false);
		} catch {
			setErreurGenerale('Une erreur réseau est survenue. Vérifiez votre connexion et réessayez.');
		} finally {
			setChargement(false);
		}
	};

	return (
		<div className="vx-agency-page">

			{/* Navbar */}
			<header className="vx-nav-wrap">
				<div className="vx-shell">
					<nav className="vx-nav">
						<Link to="/" className="vx-brand">
							<div className="vx-brand-mark">
								<img src="/assets/images/logo.png" alt="UltimateXDrive" style={{ width: '40px', height: '40px', objectFit: 'contain' }} />
							</div>
							<span className="vx-brand-name">UltimateXDrive</span>
						</Link>
						<div />
						<div className="vx-nav-cta">
							<button type="button" className="vx-btn vx-btn-ghost" onClick={() => navigate(-1)}>
								<FiArrowLeft size={14} aria-hidden="true" /> Retour
							</button>
						</div>
					</nav>
				</div>
			</header>

			<main className="vx-agency-main">

				{/* Panneau gauche */}
				<div className="vx-agency-left">
					<div className="vx-agency-left-inner">
						<span className="vx-agency-kicker">
							<FiZap size={13} aria-hidden="true" /> Réseau partenaire
						</span>
						<h1 className="vx-agency-title">Devenez<br /><em>partenaire.</em></h1>
						<p className="vx-agency-subtitle">
							Soumettez votre dossier pour rejoindre le réseau UltimateX Drive et recevoir des demandes clients qualifiées.
						</p>
						<div className="vx-agency-doc-checklist">
							<p className="vx-agency-doc-checklist-title">
								<FiFileText size={13} aria-hidden="true" /> Documents requis
							</p>
							<ul className="vx-agency-doc-list">
								<li><FiCheckCircle size={12} aria-hidden="true" /> Registre de commerce (RC)</li>
								<li><FiCheckCircle size={12} aria-hidden="true" /> NIF / Numéro fiscal</li>
								<li><FiCheckCircle size={12} aria-hidden="true" /> Statuts de la société</li>
								<li><FiCheckCircle size={12} aria-hidden="true" /> Pièce d&apos;identité du responsable (CIN)</li>
								<li><FiCheckCircle size={12} aria-hidden="true" /> Assurance flotte automobile</li>
								<li><FiCheckCircle size={12} aria-hidden="true" /> Autorisation d&apos;exploitation</li>
								<li><FiCheckCircle size={12} aria-hidden="true" /> Carte grise d&apos;un véhicule</li>
								<li><FiCheckCircle size={12} aria-hidden="true" /> Photo façade de l&apos;agence</li>
								<li><FiCheckCircle size={12} aria-hidden="true" /> Photo du responsable sur place</li>
							</ul>
						</div>
						<div className="vx-agency-alert">
							<p className="vx-agency-alert-label">
								<FiAlertCircle size={12} aria-hidden="true" /> Photo obligatoire sur place
							</p>
							<p className="vx-agency-alert-text">
								<strong>Prenez une photo depuis votre appareil :</strong> visage bien visible, bon éclairage, la même personne que sur la CIN.
							</p>
						</div>
					</div>
				</div>

				{/* Formulaire */}
				<div className="vx-agency-right">
					<div className="vx-agency-right-inner">
						<div className="vx-agency-form-head">
							<span className="vx-section-kicker">Inscription agence</span>
							<h2 className="vx-agency-form-title">Constituez votre dossier</h2>
							<p className="vx-agency-form-sub">Remplissez les informations et fournissez les documents requis pour valider votre partenariat.</p>
						</div>

						<form className="vx-agency-card" onSubmit={handleSoumission} noValidate>

							<div className="vx-agency-section-label">Informations de l&apos;agence</div>

							<div className="vx-agency-row">
								<div className="vx-agency-field">
									<label className="vx-agency-label" htmlFor="vx-agency-name">Nom de l&apos;agence</label>
									<input id="vx-agency-name" name="agencyName" type="text" className="vx-agency-input"
										placeholder="UltimateX Cars" value={formulaire.agencyName} onChange={handleChamp} />
									{erreurs.agencyName && <p className="vx-agency-field-error">{erreurs.agencyName}</p>}
								</div>
								<div className="vx-agency-field">
									<label className="vx-agency-label" htmlFor="vx-owner-name">Responsable</label>
									<input id="vx-owner-name" name="ownerFullName" type="text" className="vx-agency-input"
										placeholder="Karim Benali" value={formulaire.ownerFullName} onChange={handleChamp} />
									{erreurs.ownerFullName && <p className="vx-agency-field-error">{erreurs.ownerFullName}</p>}
								</div>
							</div>

							<div className="vx-agency-row">
								<div className="vx-agency-field">
									<label className="vx-agency-label" htmlFor="vx-agency-email">Email professionnel</label>
									<input id="vx-agency-email" name="professionalEmail" type="email" className="vx-agency-input"
										placeholder="contact@agence.com" value={formulaire.professionalEmail} onChange={handleChamp} />
									{erreurs.professionalEmail && <p className="vx-agency-field-error">{erreurs.professionalEmail}</p>}
								</div>
								<div className="vx-agency-field">
									<label className="vx-agency-label" htmlFor="vx-agency-phone">Téléphone</label>
									<input id="vx-agency-phone" name="phoneNumber" type="tel" className="vx-agency-input"
										placeholder="+212 6 00 00 00 00" value={formulaire.phoneNumber} onChange={handleChamp} />
									{erreurs.phoneNumber && <p className="vx-agency-field-error">{erreurs.phoneNumber}</p>}
								</div>
							</div>

							<div className="vx-agency-field">
								<label className="vx-agency-label" htmlFor="vx-agency-address">Adresse du siège</label>
								<textarea id="vx-agency-address" name="agencyAddress" className="vx-agency-input"
									placeholder="Rue, ville, code postal, pays" value={formulaire.agencyAddress} onChange={handleChamp} />
								{erreurs.agencyAddress && <p className="vx-agency-field-error">{erreurs.agencyAddress}</p>}
							</div>

							<div className="vx-agency-field">
								<label className="vx-agency-label" htmlFor="vx-agency-website">
									Site web <span className="vx-agency-optional">(optionnel)</span>
								</label>
								<input id="vx-agency-website" name="website" type="url" className="vx-agency-input"
									placeholder="https://www.votreagence.com" value={formulaire.website} onChange={handleChamp} />
								{erreurs.website && <p className="vx-agency-field-error">{erreurs.website}</p>}
							</div>

							<div className="vx-agency-section-label" style={{ marginTop: '0.5rem' }}>Documents légaux</div>

							<section className="vx-agency-docs" aria-label="Documents officiels">
								<div className="vx-agency-row">
									<div className="vx-agency-field">
										<label className="vx-agency-label" htmlFor="vx-rc">Registre de commerce (RC)</label>
										<div className="vx-agency-upload-wrap">
											<FiFileText size={14} />
											<input id="vx-rc" type="file" name="rcDocument" className="vx-agency-file"
												onChange={handleFichier} accept=".pdf,.jpg,.jpeg,.png" />
										</div>
										{fichiers.rcDocument && <p className="vx-agency-file-name">✓ {fichiers.rcDocument.name}</p>}
										{erreurs.rcDocument && <p className="vx-agency-field-error">{erreurs.rcDocument}</p>}
									</div>
									<div className="vx-agency-field">
										<label className="vx-agency-label" htmlFor="vx-nif">NIF / Numéro fiscal</label>
										<div className="vx-agency-upload-wrap">
											<FiFileText size={14} />
											<input id="vx-nif" type="file" name="nifDocument" className="vx-agency-file"
												onChange={handleFichier} accept=".pdf,.jpg,.jpeg,.png" />
										</div>
										{fichiers.nifDocument && <p className="vx-agency-file-name">✓ {fichiers.nifDocument.name}</p>}
										{erreurs.nifDocument && <p className="vx-agency-field-error">{erreurs.nifDocument}</p>}
									</div>
								</div>

								<div className="vx-agency-row">
									<div className="vx-agency-field">
										<label className="vx-agency-label" htmlFor="vx-id-card">Pièce d&apos;identité (CIN)</label>
										<div className="vx-agency-upload-wrap">
											<FiFileText size={14} />
											<input id="vx-id-card" type="file" name="ownerIdentityDocument" className="vx-agency-file"
												onChange={handleFichier} accept=".pdf,.jpg,.jpeg,.png" />
										</div>
										{fichiers.ownerIdentityDocument && <p className="vx-agency-file-name">✓ {fichiers.ownerIdentityDocument.name}</p>}
										{erreurs.ownerIdentityDocument && <p className="vx-agency-field-error">{erreurs.ownerIdentityDocument}</p>}
									</div>
									<div className="vx-agency-field">
										<label className="vx-agency-label" htmlFor="vx-assurance">Attestation d&apos;assurance</label>
										<div className="vx-agency-upload-wrap">
											<FiShield size={14} />
											<input id="vx-assurance" type="file" name="assuranceDocument" className="vx-agency-file"
												onChange={handleFichier} accept=".pdf,.jpg,.jpeg,.png" />
										</div>
										{fichiers.assuranceDocument && <p className="vx-agency-file-name">✓ {fichiers.assuranceDocument.name}</p>}
									</div>
								</div>
							</section>

							<div className="vx-agency-section-label" style={{ marginTop: '0.5rem' }}>Photos &amp; visuels</div>

							<section className="vx-agency-docs" aria-label="Documents visuels">
								<div className="vx-agency-row">
									<div className="vx-agency-field">
										<label className="vx-agency-label" htmlFor="vx-front-photo">Photo façade de l&apos;agence</label>
										<div className="vx-agency-upload-wrap">
											<FiFileText size={14} />
											<input id="vx-front-photo" type="file" name="agencyFrontPhoto" className="vx-agency-file"
												accept="image/*" capture="environment" onChange={handleFichier} />
										</div>
										{fichiers.agencyFrontPhoto && <p className="vx-agency-file-name">✓ {fichiers.agencyFrontPhoto.name}</p>}
										{erreurs.agencyFrontPhoto && <p className="vx-agency-field-error">{erreurs.agencyFrontPhoto}</p>}
									</div>
									<div className="vx-agency-field">
										<label className="vx-agency-label" htmlFor="vx-logo">
											Logo <span className="vx-agency-optional">(optionnel)</span>
										</label>
										<div className="vx-agency-upload-wrap">
											<FiFileText size={14} />
											<input id="vx-logo" type="file" name="agencyLogo" className="vx-agency-file"
												onChange={handleFichier} accept="image/*" />
										</div>
										{fichiers.agencyLogo && <p className="vx-agency-file-name">✓ {fichiers.agencyLogo.name}</p>}
									</div>
								</div>

								<div className="vx-agency-photo-card">
									<div className="vx-agency-field">
										<label className="vx-agency-label" htmlFor="vx-live-photo">
											<FiShield size={12} aria-hidden="true" /> Photo du responsable sur place
										</label>
										<div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
											<CameraCapture onCapture={handlePhotoDirigeant} existingFile={fichiers.ownerLivePhoto} label="Prendre la photo du responsable" />
											<div style={{ display: 'none' }}>
												<input id="vx-live-photo" type="file" name="ownerLivePhoto" className="vx-agency-file"
													accept="image/*" onChange={handleFichier} />
											</div>
											<p className="vx-agency-note">
												La caméra s&apos;ouvre directement. Le visage doit être net, bien éclairé, et correspondre à la CIN.
											</p>
											{fichiers.ownerLivePhoto && <p className="vx-agency-file-name">✓ {fichiers.ownerLivePhoto.name}</p>}
											{erreurs.ownerLivePhoto && <p className="vx-agency-field-error">{erreurs.ownerLivePhoto}</p>}
										</div>
									</div>
								</div>
							</section>

							<div className="vx-agency-section-label" style={{ marginTop: '0.5rem' }}>Accès au compte</div>

							<div className="vx-agency-row">
								<div className="vx-agency-field">
									<label className="vx-agency-label" htmlFor="vx-agency-password">Mot de passe</label>
									<div className="vx-agency-pw-wrap">
										<input id="vx-agency-password" name="password"
											type={afficherMdp ? 'text' : 'password'} className="vx-agency-input"
											placeholder="Minimum 8 caractères" value={formulaire.password} onChange={handleChamp} />
										<button type="button" className="vx-agency-pw-toggle"
											onClick={() => setAfficherMdp((v) => !v)}
											aria-label={afficherMdp ? 'Masquer' : 'Afficher'}>
											{afficherMdp ? <FiEyeOff size={16} /> : <FiEye size={16} />}
										</button>
									</div>
									{erreurs.password && <p className="vx-agency-field-error">{erreurs.password}</p>}
								</div>
								<div className="vx-agency-field">
									<label className="vx-agency-label" htmlFor="vx-agency-confirm">Confirmer</label>
									<div className="vx-agency-pw-wrap">
										<input id="vx-agency-confirm" name="confirmPassword"
											type={afficherConfirm ? 'text' : 'password'} className="vx-agency-input"
											placeholder="Confirmez le mot de passe" value={formulaire.confirmPassword} onChange={handleChamp} />
										<button type="button" className="vx-agency-pw-toggle"
											onClick={() => setAfficherConfirm((v) => !v)}
											aria-label={afficherConfirm ? 'Masquer' : 'Afficher'}>
											{afficherConfirm ? <FiEyeOff size={16} /> : <FiEye size={16} />}
										</button>
									</div>
									{erreurs.confirmPassword && <p className="vx-agency-field-error">{erreurs.confirmPassword}</p>}
								</div>
							</div>

							<label className="vx-agency-terms">
								<input type="checkbox" name="acceptedTerms" checked={formulaire.acceptedTerms} onChange={handleCgu} />
								<span className="vx-agency-terms-text">
									J&apos;accepte les <a href="#terms">conditions d&apos;utilisation</a> et la{' '}
									<a href="#privacy">politique de confidentialité</a>
								</span>
							</label>
							{erreurs.acceptedTerms && <p className="vx-agency-field-error">{erreurs.acceptedTerms}</p>}

							<button type="submit" className="vx-btn vx-btn-solid vx-agency-submit" disabled={chargement}>
								{chargement ? (
									<span className="vx-agency-loading">
										<span className="vx-agency-dot" />
										<span className="vx-agency-dot" />
										<span className="vx-agency-dot" />
										Envoi du dossier…
									</span>
								) : (
									<>
										<FiUploadCloud size={15} aria-hidden="true" />
										Envoyer ma demande
										<FiArrowRight size={14} aria-hidden="true" />
									</>
								)}
							</button>

							{erreurGenerale && <p className="vx-agency-form-error" role="alert">⚠ {erreurGenerale}</p>}
							{messageSucces && <p className="vx-agency-form-success">✓ {messageSucces}</p>}
						</form>

						<p className="vx-agency-footer">
							Déjà partenaire ? <Link to="/login">Se connecter</Link>
						</p>
					</div>
				</div>
			</main>
		</div>
	);
}

export default Signupagence;
